module.exports = __webpack_public_path__ + "static/media/how.b6281597.png";